module.exports = __webpack_public_path__ + "static/media/logo-menu.be563417.png";